import React, { Component } from 'react';
import './SubCategoryButton.scss';
import PropTypes from 'prop-types';
import i18n from '../../../i18n';

class SubCategoryButton extends Component {
    businessCategory = [
        { label: i18n.t("categoryfiltering.businesscategory.entire"), key: "전체" },
        // 안쓰는 컴포넌트라 주석 처리해둠
        //{ label: i18n.t("categoryfiltering.businesscategory.ecommerce"), key: "E커머스" },
        { label: i18n.t("categoryfiltering.businesscategory.beauty"), key: "뷰티" },
        { label: i18n.t("categoryfiltering.businesscategory.fashion"), key: "패션" },
        { label: i18n.t("categoryfiltering.businesscategory.cafe_food_bakery"), key: "카페/음식/베이커리" },
        { label: i18n.t("categoryfiltering.businesscategory.lodging_travel_leisure"), key: "숙박/여행/레저" },
        { label: i18n.t("categoryfiltering.businesscategory.health_sports"), key: "헬스/스포츠" },
        { label: i18n.t("categoryfiltering.businesscategory.shopping mall_wholesale"), key: "쇼핑몰/도소매" },
        { label: i18n.t("categoryfiltering.businesscategory.realestate"), key: "부동산" },
        { label: i18n.t("categoryfiltering.businesscategory.educational"), key: "교육 서비스" },
        { label: i18n.t("categoryfiltering.businesscategory.medical"), key: "의료 서비스" },
        { label: i18n.t("categoryfiltering.businesscategory.professional"), key: "전문직 서비스" },
        { label: i18n.t("categoryfiltering.businesscategory.business"), key: "기업홍보" },
        { label: i18n.t("categoryfiltering.businesscategory.app_mobile"), key: "앱/모바일게임" },
        { label: i18n.t("categoryfiltering.businesscategory.event"), key: "이벤트 영상" },
        { label: i18n.t("categoryfiltering.businesscategory.social"), key: "소셜 영상" },
        { label: i18n.t("categoryfiltering.businesscategory.leaflet"), key: "전단지" },
        { label: i18n.t("categoryfiltering.businesscategory.others"), key: "기타" }
    ];

    styleCategory = [
        { label: i18n.t("categoryfiltering.stylecategory.entire"), key: "전체" },
        { label: i18n.t("categoryfiltering.stylecategory.4CutLog"), key: "4컷 log", hot: "https://front.videomonster.com/images-u6yd72dy/web/hot@3x.png" },
        { label: i18n.t("categoryfiltering.businesscategory.title_intro"), key: "타이틀/인트로"},
        { label: i18n.t("categoryfiltering.businesscategory.youtubesource"), key: "유튜브 소스" },
        { label: i18n.t("categoryfiltering.stylecategory.dynamic"), key: "역동적" },
        { label: i18n.t("categoryfiltering.stylecategory.cheerful"), key: "경쾌한" },
        { label: i18n.t("categoryfiltering.stylecategory.sentimental"), key: "감성적" },
        { label: i18n.t("categoryfiltering.stylecategory.simple"), key: "심플한" },
        { label: i18n.t("categoryfiltering.stylecategory.vintage"), key: "빈티지" },
        { label: i18n.t("categoryfiltering.stylecategory.black_white"), key: "흑백" },
        { label: i18n.t("categoryfiltering.stylecategory.colourful"), key: "컬러풀한" },
        { label: i18n.t("categoryfiltering.stylecategory.cute"), key: "귀여운" },
        { label: i18n.t("categoryfiltering.stylecategory.season"), key: "계절감" },
        { label: i18n.t("categoryfiltering.stylecategory.subtitle_based"), key: "자막위주" },
    ];
    renderTabel = (whichMainCateGoryClick, onCheckboxChanged, categories) => {
        let category;
        let categoryName;
        if (whichMainCateGoryClick === "marketing") {
            category = this.businessCategory
            categoryName = "businessCategory"
        } else {
            category = this.styleCategory
            categoryName = "styleCategory"
        }
        return (
            category.map(item => {
                return (
                    <div key={item.key} className={`SubCategoryButton-item`}>
                        <input value={item.key} onChange={onCheckboxChanged(categoryName, item.key)} checked={categories[categoryName][item.key]} id={item.key} type={"checkbox"}></input>
                        <label htmlFor={item.key} key={item.key}>
                            <span>
                                {item.hot && !categories[categoryName][item.key] && <img className="hotImg" src={item.hot} alt="hotImg"></img>}
                                {item.new && !categories[categoryName][item.key] && <img className="newImg" src={item.new} alt="newImg"></img>}
                                {item.label}
                            </span>
                        </label>
                    </div>

                )
            })
        )
    }
    render() {
        const { whichMainCateGoryClick, onCheckboxChanged, categories } = this.props
        return (
            <div className="SubCategoryButton-container">
                {this.renderTabel(whichMainCateGoryClick, onCheckboxChanged, categories)}
            </div>
        );
    }
}

SubCategoryButton.propTypes = {

};

export default SubCategoryButton;